import { palette } from '../palette'

// For the main <Layout> that wraps most pages
export default `
.notistack-Snackbar .notistack-MuiContent {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border-radius: 12px !important;
}

.notistack-Snackbar .notistack-MuiContent > div:first-of-type {
    align-self: center;
}

.notistack-Snackbar .notistack-MuiContent > div {
    align-self: flex-start;
}

.notistack-Snackbar .notistack-MuiContent.notistack-MuiContent-error {
    background-color: ${palette.error.main};
}
`
